import React from 'react';

const onglets = [
  { key: 'produits', label: 'Produits' },
  { key: 'categories', label: 'Catégories' },
  { key: 'publicites', label: 'Publicités' },
  { key: 'videos', label: 'Vidéos' },
  { key: 'sponsorises', label: 'Sponsorisé' },
  { key: 'commandes', label: 'Commandes' },
  { key: 'utilisateurs', label: 'Utilisateurs' }
];

export default function MenuAdmin({ actif, onChange }) {
  return (
    <div className="flex flex-wrap gap-2 rounded-2xl border border-gray-200 bg-white p-3">
      {onglets.map((o) => (
        <button
          key={o.key}
          onClick={() => onChange(o.key)}
          className={`rounded-xl px-4 py-2 text-sm font-semibold transition ${
            actif === o.key ? 'bg-marega-600 text-white' : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
